import { courseLessonActions } from './courseLessonSlice'
import { fetchCachedHelper } from '../../../api/api'

export const markLessonAsCompletedApi = lessonId => async dispatch => {
    dispatch(courseLessonActions.markLessonAsCompleted())
    try {
        const response = await fetchCachedHelper.post(
            `/api/Courselesson/${lessonId}/completed`
        )
        let markLessonAsCompletedData = response.data

        dispatch(
            courseLessonActions.markLessonAsCompletedSuccess(
                markLessonAsCompletedData
            )
        )
    } catch (e) {
        dispatch(courseLessonActions.markLessonAsCompletedError(e.message))
    }
}
